/** Detect a Browser on iPod device */
export default function isIPod(ua) {
	return /iPod/i.test(ua);
}
